import React, { useState } from 'react';
import { useTeam } from './TeamContext';
import SwaggerUIComponent from './SwaggerUIComponent';

const Episode1 = () => {
  const { team, saveTeamDetails } = useTeam();
  const [newPaymentsGatewayUrl, setNewPaymentsGatewayUrl] = useState(team.payment_gateway_url || '');

  const handleSubmit = () => {
    //const episodes_unlocked = team.episodes_unlocked || []
    //const episode_id = 1
    //const updatedEpisodes = [...episodes_unlocked, episode_id].sort((a, b) => a - b);

    const updatedTeam = {
      ...team,
      //episodes_unlocked: updatedEpisodes.join(','),
      payment_gateway_url: newPaymentsGatewayUrl,
    };

    saveTeamDetails(updatedTeam);
  };

  return (
    <div>
      <div>
        <h2 className="font-lustra text-3xl text-white text-center mt-12 mb-6">
        Episodio 1: BigBang Payments Processor
        </h2>
        <div className="mt-2 mb-2 text-lg space-y-4 text-white">
          <p>
            En algún rincón oscuro de la galaxia, donde los asteroides chocan tan seguido como algunas transacciones,
            se alza la empresa de procesamiento de pagos <b>BigBang</b>.
          </p>
          <p>
            Nuestro Payments Processor es un servicio robusto, confiable y, según nuestro departamento de marketing,
            "más rápido que un salto al hiperespacio". Claro, eso es si no contamos esos "pequeños" retrasos cuando
            nuestras pasarelas caen en algún agujero negro. Pero no se preocupen, porque nuestro sistema de soporte
            al cliente estará allí para... desearles suerte!
          </p>
          <p>
            ¿Por qué confiar en nosotros? Fuimos los únicos que respondieron cuando la galaxia necesitaba un servicio
            de procesamiento de pagos... así que técnicamente no tenían otra opción.
          </p>
          <p>
            Por suerte, y gracias a los dioses de la galaxia (que no estamos seguros si existen, pero les agradecemos
            igual), <b>BigBang</b> cuenta con documentación de sus APIs en OpenAPI. Así que, aunque el caos intergaláctico
            a veces nos abrume, al menos tendrás una guía clara para integrar nuestros servicios sin necesidad de consultar
            a un oráculo estelar.
          </p>
          <p>
            Porque cuando se trata de pagos intergalácticos, no necesitas el mejor servicio, solo uno que funcione... a veces. 🚀
          </p>
        </div>

        <div className="mt-8 mb-8 bg-white p-4 rounded-lg shadow-md mx-20">
          <SwaggerUIComponent
            url="openapi/payments_processor_api-GDAY-oas30.json" 
          />
        </div>

        <h3 className="font-lustra text-2xl text-white text-center mt-6 mb-6">
          Estados de las transacciones
        </h3>
        <div className="mt-2 mb-2 text-lg space-y-4 text-white">
          <p>
            En <span className="font-bold">BigBang</span>, cada transacción comienza su épico viaje galáctico
            en el estado <span className="bg-gray-100 text-red-600 font-mono px-1 rounded">AUTHORIZED</span>. En este punto,
            el pago está en la pista de lanzamiento, con los motores encendidos, pero aún esperando el visto bueno del centro
            de control.
          </p>
          <p>
            Solo cuando nuestras complejas y, a veces caprichosas, pasarelas de pago logran descifrar los misterios de
            los flujos interdimensionales (y si ningún agujero negro decide interferir), el estado de la transacción cambiará
            a <span className="bg-gray-100 text-red-600 font-mono px-1 rounded">PROCESSED</span>. Este es el momento de gloria
            en el que el pago ha cruzado las fronteras de la incertidumbre y puede ser considerado oficialmente un éxito interestelar.
          </p>
          <p>
            Claro, puede que de vez en cuando, en esta vasta galaxia de probabilidades, un pago se quede varado entre dimensiones
            o incluso haga una visita inesperada a un universo paralelo. Pero tranquilos, porque siempre podemos confiar en el viejo
            mantra de BigBang: <span className="font-bold">"Si no está PROCESSED, al menos lo está intentando..."</span>.
          </p>
          <p>
            Recuerden: en el cosmos de los pagos, lo único constante es la incertidumbre, y lo único que puedes hacer es
            asegurarte de estar siempre listo para lo inesperado. 🚀
          </p>
        </div>
        <h3 className="font-lustra text-3xl text-white text-center mt-12 mb-6">
          Episodio 1.1: Las Puertas del Caos
        </h3>
        <div className="mt-2 mb-2 text-lg space-y-4 text-white">
          <p>
            Y así, <span className="font-bold">{team.name}</span>, llega el momento de la verdad. <span className="font-bold">
              Galactic Payments</span>, ese titán intergaláctico de las
            transacciones (o eso dicen ellos), está listo para comenzar a enviar tráfico hacia su
            flamante Payments Gateway. Pero antes de que los asteroides choquen y los gráficos exploten,
            hay un pequeño detalle que deben atender:
          </p>
          <p>
            <b>¡Necesitamos su URL!</b> Sí, esa misma dirección que conecta su gateway con las estrellas...
            o con un dashboard lleno de errores, dependiendo de qué tan listos estén.
          </p>
          <p>
            Ingresar su URL no es solo un acto de confianza, es un salto al vacío. A partir
            de ese momento, Galactic Payments comenzará a enviar tráfico como si el hiperespacio estuviera
            en oferta. Pero cuidado:
          </p>
          <p>
            <div>
              <ul className="list-disc pl-8 space-y-2">
                <li className="text-gray-200">
                <span className="font-bold">Si su gateway no está listo</span>, el tráfico será implacable.
                  Prepárense para ver cómo las métricas se disparan... y sus puntos se desploman.
                </li>
                <li className="text-gray-200">
                  <span className="font-bold">Si sus sistemas no procesan correctamente,</span> el caos
                  será su nuevo compañero. Mensajes fuera de orden, duplicados, respuestas que parecen
                  venir de una dimensión alterna... todo es posible.
                </li>
                <li className="text-gray-200">
                  <span className="font-bold">Y si todo funciona bien...</span> bueno, eso sería un milagro
                  digno de un nuevo capítulo en las crónicas de la galaxia.
                </li>
              </ul>
            </div>
          </p>
          <p>
            Recuerden, una URL mal configurada es como abrir una ventana en medio de una tormenta espacial.
            ¿Pero una bien configurada? Esa es su oportunidad de demostrar que están listos para dominar el
            universo de los pagos.
          </p>
          <p>
            ¡Adelante con sus URLs y que los dioses de la observabilidad los acompañen! 🚀
          </p>
        </div>
        
        <div className="mt-2 mb-2 text-lg space-y-4 text-white">
          <div className="mt-4 border-t border-gray-100">
            <div className="mt-4 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
              <div className="sm:col-span-6">
                <label htmlFor="payment_gateway_url" className="block text-lg font-bold leading-6 text-white">
                  Payments Gateway URL
                </label>
                <div className="mt-2">
                  <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-full">
                    <input
                      id="payment_gateway_url"
                      name="payment_gateway_url"
                      type="text"
                      value={newPaymentsGatewayUrl}
                      onChange={(e) => setNewPaymentsGatewayUrl(e.target.value)}
                      className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-white placeholder:text-gray-400 focus:ring-0 sm:text-base sm:leading-6"
                    />
                  </div>
                  <p className="text-sm leading-6 p-2">
                    La URL deberá contener el path completo: https://$api-id.execute-api.us-east-1.amazonaws.com/gday/v1/transactions
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-6 flex items-center gap-x-6 justify-end">
            <button
              onClick={handleSubmit}
              className="rounded-md bg-blue-700 px-3 py-2 text-lg font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Estamos Listos!
            </button>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Episode1;

